import React from 'react';
import { IIntegrationProps } from '../types';

export const IntegrationContext = React.createContext<IIntegrationProps>(null);